import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAuthHeaders } from "../../utils/apiHeaders";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchCurrentCurrency = createAsyncThunk(
  "currency/fetchCurrentCurrency",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/currency", {
        method: "GET",
        signal: thunkApi.signal,
        headers: getAuthHeaders(language),
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve currency"
        );
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

export var fetchSupportedCurrencies = createAsyncThunk(
  "currency/fetchSupportedCurrencies",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/currencies", {
        method: "GET",
        signal: thunkApi.signal,
        headers: getAuthHeaders(language),
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve currencies"
        );
      }

      return Array.isArray(responseData.data) ? responseData.data : [];
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

export var selectCurrency = createAsyncThunk(
  "currency/selectCurrency",
  async function (payload, thunkApi) {
    try {
      var language = payload.language;
      var response = await fetch(API_BASE_URL + "/currency/select", {
        method: "POST",
        signal: thunkApi.signal,
        headers: Object.assign(
          { "Content-Type": "application/json" },
          getAuthHeaders(language)
        ),
        body: JSON.stringify({ currency: payload.currency }),
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to select currency"
        );
      }

      thunkApi.dispatch(fetchCurrentCurrency(language));
      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  current: null,
  supported: [],

  currentLoading: false,
  currentError: "",

  supportedLoading: false,
  supportedError: "",

  selectLoading: false,
  selectError: "",
};

var currencySlice = createSlice({
  name: "currency",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchCurrentCurrency.pending, function (state) {
        state.currentLoading = true;
        state.currentError = "";
      })
      .addCase(fetchCurrentCurrency.fulfilled, function (state, action) {
        state.currentLoading = false;
        state.current = action.payload;
      })
      .addCase(fetchCurrentCurrency.rejected, function (state, action) {
        state.currentLoading = false;
        state.currentError = action.payload || "Unable to retrieve currency";
      })

      .addCase(fetchSupportedCurrencies.pending, function (state) {
        state.supportedLoading = true;
        state.supportedError = "";
      })
      .addCase(fetchSupportedCurrencies.fulfilled, function (state, action) {
        state.supportedLoading = false;
        state.supported = action.payload;
      })
      .addCase(fetchSupportedCurrencies.rejected, function (state, action) {
        state.supportedLoading = false;
        state.supportedError =
          action.payload || "Unable to retrieve currencies";
      })

      .addCase(selectCurrency.pending, function (state) {
        state.selectLoading = true;
        state.selectError = "";
      })
      .addCase(selectCurrency.fulfilled, function (state) {
        state.selectLoading = false;
      })
      .addCase(selectCurrency.rejected, function (state, action) {
        state.selectLoading = false;
        state.selectError = action.payload || "Unable to select currency";
      });
  },
});

export default currencySlice.reducer;
